import { render, staticRenderFns } from "./AssignFormsVisitMedical.vue?vue&type=template&id=c95b9efc&"
import script from "./AssignFormsVisitMedical.vue?vue&type=script&lang=js&"
export * from "./AssignFormsVisitMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports